module.exports = __webpack_public_path__ + "img/logo_ethereum.6ba6ecef.png";